<aside class="site-floating-actions" aria-label="Quick contact options">
  <nav class="site-floating-actions__side" aria-label="Contact GHRU">
    <button class="site-floating-actions__enquire" type="button" (click)="toggleEnquiry()"
      [attr.aria-expanded]="isEnquiryOpen" aria-controls="floating-enquiry-modal"><span>Enquire Now</span></button>
    <a class="site-floating-actions__whatsapp" [class.is-expanded]="isWhatsappExpanded"
      href="https://api.whatsapp.com/send?phone=+919307900682&amp;text=Hi%2C%20I%20need%20assistance%20for%20Admission%20at%20your%20GHRU%20University%20for%20Academic%20Year%202026-27."
      target="_blank" rel="noopener noreferrer" aria-label="Chat with GHRU on WhatsApp">
      <app-icon name="whatsapp"></app-icon>
      <span class="site-floating-actions__whatsapp-label">Whatsapp Chat</span>
    </a>
    <!-- Open with its label at the top of the page; folds to the icon once the visitor scrolls -->
    <a class="site-floating-actions__apply" [class.is-open]="!isWhatsappExpanded"
      href="http://admissions.ghru.edu.in/" target="_blank" rel="noopener noreferrer"
      aria-label="Apply now for admission (opens in a new tab)">
      <app-icon name="edit"></app-icon>
      <span class="site-floating-actions__apply-label">Apply Now</span>
    </a>
  </nav>

  <!-- Old bottom-right Apply Now button; Apply Now now sits under WhatsApp in the side bar
  <div class="floadting-tab">
    <a href="http://admissions.ghru.edu.in/" target="_blank"
      rel="noopener noreferrer" class="floating-apply-btn site-floating-actions__apply">
      <app-icon name="edit"></app-icon>
      <span>Apply Now</span>
    </a>
  </div>
  -->

  <div class="npf_chatbots" data-w="9d4303fa6f5d402cb4dcd0e0b7c88f29" style="display: none;"></div>

  <div class="enquiry-modal" [class.enquiry-modal--open]="isEnquiryOpen"
    [attr.aria-hidden]="!isEnquiryOpen" (click)="closeEnquiry()">
    <section class="enquiry-modal__content" id="floating-enquiry-modal" role="dialog" aria-modal="true"
      aria-labelledby="floating-enquiry-title" (click)="$event.stopPropagation()">
      <header class="enquiry-modal__header">
        <h2 id="floating-enquiry-title">Enquire Now</h2>
        <button type="button" (click)="closeEnquiry()" aria-label="Close enquiry form">
          <app-icon name="close"></app-icon>
        </button>
      </header>
      <div class="npf_wgts" data-height="550px" data-w="cfdac50511b7cbcf27c0cdb248110f1f"></div>
    </section>
  </div>
</aside>
